// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"d84478b6","14":"4a3b56bd","18":"8be11500","65":"79b0d1d8","362":"58fcb78b","691":"b23c6588"}[chunkId] + ".chunk.js";
};